import styled, { css } from 'styled-components';

import type { ScArrowProps } from '@/components/NativeSlider/helpers';

const ScArrow = styled.button<ScArrowProps>`
  position: absolute;
  display: block;
  border: none;
  background: none;
  z-index: 2;
  width: 16px;
  height: 40px;
  top: 50%;
  transform: translateY(-50%) translateX(0);
  margin-top: -18px;
  cursor: pointer;
  transition: all 0.3s ease 0s;
  opacity: 1;

  ${({ visibleForMob }) =>
    !visibleForMob &&
    css`
      @media (max-width: 530px) {
        display: none;
      }
    `}
`;

export const ScArrowNext = styled(ScArrow)`
  inset: ${({ inset }) => inset ?? '50% 32px auto auto'};

  @media (hover: hover) {
    &:hover {
      &:before {
        transform: scale(1.2) rotate(-65deg);
        top: 34px;
      }
      &:after {
        transform: scale(1.2) rotate(65deg);
        top: 8px;
      }
    }
  }

  &:before {
    content: '';
    display: block;
    width: 24px;
    height: 1px;
    background-color: ${({ theme }) => theme.whiteColor};
    position: absolute;
    top: 30px;
    left: -4px;
    transform: rotate(-50deg);
    transition: all 0.3s ease 0s;
  }
  &:after {
    content: '';
    display: block;
    width: 24px;
    height: 1px;
    background-color: ${({ theme }) => theme.whiteColor};
    position: absolute;
    top: 12px;
    left: -4px;
    transform: rotate(50deg);
    transition: all 0.3s ease 0s;
  }
  ${({ hide }) =>
    hide &&
    css`
      transform: translateY(-50%) translateX(-32px);
      opacity: 0;
    `}
`;

export const ScArrowPrev = styled(ScArrow)`
  inset: ${({ inset }) => inset ?? '50% auto auto 32px'};

  @media (hover: hover) {
    &:hover {
      &:after {
        transform: scale(1.2) rotate(-65deg);
        top: 8px;
      }
      &:before {
        transform: scale(1.2) rotate(65deg);
        top: 34px;
      }
    }
  }

  &:before {
    content: '';
    display: block;
    width: 24px;
    height: 1px;
    background-color: ${({ theme }) => theme.whiteColor};
    position: absolute;
    top: 30px;
    left: -4px;
    transform: rotate(50deg);
    transition: all 0.3s ease 0s;
  }
  &:after {
    content: '';
    display: block;
    width: 24px;
    height: 1px;
    background-color: ${({ theme }) => theme.whiteColor};
    position: absolute;
    top: 12px;
    left: -4px;
    transform: rotate(-50deg);
    transition: all 0.3s ease 0s;
  }
  ${({ hide }) =>
    hide &&
    css`
      transform: translateY(-50%) translateX(32px);
      opacity: 0;
    `}
`;
